import { useDispatch, useSelector } from 'react-redux';
import { openModal, setModalType } from '../../../../Features/dropTrackProductsSlice';

function Alert() {
    const dispatch = useDispatch();

    const activeAlert = useSelector((state) => state.dropTrackProducts.droptrackProductPage.activeAlert);

    const handleEndAction = () => {
        dispatch(setModalType('end-action'));
        dispatch(openModal());
    }

    return (
        <div className='mx-5 mt-4 bg-[#A6FFCB] border border-[#EAEAEA] p-4 rounded-lg flex items-center justify-between'>
            <div className="flex flex-col gap-2">
                <h1 className='font-semibold text-[18px] leading-5'>Created “{activeAlert.type}” Action</h1>

                {(activeAlert.startDate || activeAlert.endDate) && <p className='text-[16px] leading-5 text-[#666666]'>{activeAlert.startDate} - {activeAlert.endDate}</p>}
            </div>

            <button onClick={handleEndAction} className='font-semibold text-base bg-primaryColor hover:bg-primaryAccent px-4 py-2 rounded whitespace-nowrap text-buttonText'>End Action</button>
        </div>
    )
}

export default Alert;
